<template>
<div class="container">
  <div class="main">
    <div class="thumb-example">

      <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
        <swiper-slide class="slide-2"
          v-for="(item,i) in picData" :key="i"
          :style="{ 'background-image': 'url('+ item +')'}"
        ></swiper-slide>
        <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
      </swiper>
      <!-- swiper2 Thumbs -->
      <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
        <swiper-slide class="slide-2" v-for="(item,i) in picData" :key="i"
          :style="{ 'background-image': 'url('+ item +')'}">
        </swiper-slide>
      </swiper>

    </div>
  </div>
</div>

</template>

<script>
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'
  export default {
    name: 'swiper-example-thumbs-gallery',
    title: 'Thumbs gallery with Two-way control',
    components: {
      Swiper,
      SwiperSlide
    },
    data() {
      return {
        swiperOptionTop: {
          loop: true,
          loopedSlides: 5, // looped slides should be the same
          spaceBetween: 10,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          lazy: {
            loadPrevNext: true
          },
        },
        swiperOptionThumbs: {
          loop: true,
          loopedSlides: 5, // looped slides should be the same
          spaceBetween: 10,
          centeredSlides: true,
          slidesPerView: 'auto',
          touchRatio: 0.2,
          slideToClickedSlide: true ,
        } ,
        picData : [
          'https://dixcel.cn/prod/2020CEC-DELTA/1.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/2.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/3.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/4.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/5.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/6.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/7.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/8.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/9.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/10.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/11.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/12.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/13.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/14.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/15.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/16.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/17.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/18.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/19.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/20.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/21.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/22.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/23.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/24.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/25.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/26.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/27.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/28.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/29.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/30.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/31.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/32.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/33.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/34.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/35.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/36.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/37.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/38.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/39.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/40.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/41.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/42.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/43.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/44.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/45.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/46.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/47.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/48.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/49.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/50.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/51.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/52.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/53.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/54.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/55.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/56.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/57.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/58.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/59.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/60.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/61.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/62.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/63.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/64.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/65.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/66.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/67.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/68.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/69.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/70.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/71.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/72.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/73.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/74.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/75.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/76.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/77.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/78.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/79.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/80.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/81.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/82.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/83.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/84.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/85.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/86.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/87.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/88.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/89.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/90.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/91.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/92.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/93.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/94.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/95.jpg',
          'https://dixcel.cn/prod/2020CEC-DELTA/96.jpg',
        ]
      }
    },
    mounted() {
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.$swiper
        const swiperThumbs = this.$refs.swiperThumbs.$swiper
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
      })
    }
  }
</script>

<style lang="stylus" scoped>
  .container
    background-color : #000
    .box_one
      width: 100%;

    .box_bottom
      width: 100%;
      background-color #000


  .main {
    margin-bottom: 5px;
    width: 1003px;
    background-color: #fff;
    margin: 0 auto;
    position: relative;
    box-sizing: border-box;
    padding: 62px 50px 52px;
  }

  .thumb-example {
    height: 680px;
    background-color: $black;
  }
  .swiper {
    .swiper-slide {
      background-size: 100%;
      background-position: center center;
      background-repeat no-repeat
    }
    &.gallery-top {
      height: 80%;
      width: 100%;
    }
    &.gallery-thumbs {
      height: 20%;
      box-sizing: border-box;
      padding: $gap 0;
    }
    &.gallery-thumbs .swiper-slide {
      width: 20%;
      height: 100%;
      opacity: 0.4;
    }
    &.gallery-thumbs .swiper-slide-active {
      opacity: 1;
    }
  }
</style>
